/**
 * For some widgets (supplier, billing type, tariff)
 * the electricity fields are used to gather the information for both
 * gas & electricity. This changes their label according to the previous questions
 * @module embed/gas_and_electricity_label
 */

import { hasGas, hasDualFuel } from './form';

const SELECTOR = '.js-gas-and-electricity-label';

/**
 * @param {*} scope
 * @param {*} el
 */
function setupGasAndElectricityLabel(scope, el) {
  function updateTextContent() {
    if (hasGas(scope) && hasDualFuel(scope)) {
      el.textContent = 'energy';
    } else {
      el.textContent = 'electricity';
    }
  }
  scope.addEventListener('change', updateTextContent);
  updateTextContent();
}

export default function setupGasAndElectricityLabels(el) {
  Array.from(el.querySelectorAll(SELECTOR)).forEach(widget => {
    setupGasAndElectricityLabel(el, widget);
  });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/gas_and_electricity_label.js